import { type ComponentProps, type FromSanityGraphQL } from "@ts/components";
import { type SectionSellingPoints } from "@ts/sanity";
import React, { type FC } from "react";

type SellingPointsInputProps = ComponentProps &
  FromSanityGraphQL<SectionSellingPoints>;

export type SellingPointsOutputProps = SellingPointsInputProps;

export const withSellingPoints =
  (Component: FC<SellingPointsOutputProps>) =>
  ({ name = "SellingPoints", analytics, ...rest }: SellingPointsInputProps) => {
    Component.displayName = name;

    return <Component {...rest} />;
  };
